import styled, { css } from 'styled-components'

export const Header = styled.header(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: ${theme.space['16']};
    padding: ${theme.space['24']} ${theme.space['40']} ${theme.space['16']};
    background-color: ${theme.colors.white};
    border-bottom: ${theme.border.size['1']} solid ${theme.colors.gray400};
  `,
)

export const Logo = styled.img(
  () => css`
    width: auto;
    height: 4.8rem;
  `,
)
